import { render } from "./AppServices.vue?vue&type=template&id=c47e386e&scoped=true"
import script from "./AppServices.vue?vue&type=script&lang=js"
export * from "./AppServices.vue?vue&type=script&lang=js"

import "./AppServices.vue?vue&type=style&index=0&id=c47e386e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47e386e"]])

export default __exports__